import { Form } from 'react-bootstrap'
import { CustomFormControl,CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';

export const EntranceDateSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
             <Form.Group className="mb-3" controlId="formEntranceDate">
                <Form.Label>Frühester Eintritt</Form.Label>
                <CustomFormControl
                    colors={colors}
                    type="date"
                    name="entranceDate"
                    value={values.entranceDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.entranceDate && !errors.entranceDate}
                    isInvalid={touched.entranceDate && errors.entranceDate}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.entranceDate}
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formLocation">
                    <Form.Label>Gewünschter Einsatzort (nur bei Initiativbewerbung)</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="location"
                        value={values.location}
                        isValid={touched.location && !errors.location}
                        isInvalid={touched.location && errors.location}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.Location.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.location}
                    </Form.Control.Feedback>
                </Form.Group>
        </>
    );
};